import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SuccessPage from './pages/SuccessPage';
import OrderPaymentPage from './pages/OrderPaymentPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/order-payment" element={<OrderPaymentPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="*" element={<Navigate to="/order-payment" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
